import React from "react";
import welcome from "../../../src/assets/images/welcome.png";
import { useSidebar } from "../../content/SidebarContent";
import PageHeader from "../../components/PageHeader";
import { useNavigate } from "react-router-dom";
import { routes } from "../../helpers/constants";

const AddTenantSuccess = () => {
  const { setIsSidebarOpen } = useSidebar();
  const navigate = useNavigate();

  return (
    <section className="dashboard-page main-layout-page main-layout h-full">
      <div className="!p-0 h-full">
        <div className="main-layout-wrapper bg-white flex flex-col sticky z-1 top-0 h-full">
          <div className="flex items-baseline gap-[40px] main-sidebar-wrapper flex-1 w-full">
            {/* Dashboard */}
            <div className="flex-1 right-sidebar h-full relative w-full">
              <div className="py-6 px-3 md:ps-[24px] md:p-6 pb-[50px] md:ps-0 h-full">
                <div className="bg-white flex flex-col items-center justify-center h-full">
                  <div className="signup-process-content-text space-y-7 text-center">
                    <img
                      src={welcome}
                      alt="Welcome"
                      className="mx-auto w-[100px] md:w-[180px] h-auto"
                    />
                    <div>
                      <h1 className="text-h1 mb-1 text-blue">
                        Tenant added successfully!
                      </h1>
                      <p className="text-h2 text-gray">
                        An onboarding link has been sent to their registered
                        email address.
                      </p>
                    </div>
                  </div>

                  <div className="pt-5 space-y-4 text-center">
                    <button
                      className="btn-light-blue !text-[24px] !px-[25px] !py-[15px]"
                      onClick={() => navigate(routes.tenants)}
                    >
                      Back to Tenant List
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AddTenantSuccess;
